module.exports = __webpack_public_path__ + "eb09a9cc68ea3abc2bbb029c152b2b21.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/rose_gold_ipad.png
// module id = 568
// module chunks = 0